// extracted by mini-css-extract-plugin
export var option = "_54-1";
export var optionActive = "_54-2";
export var pill = "_54-0";